import { createRoot } from 'react-dom/client';
import '@/styles.css';
import { initCapacitorShell } from '@/platform/capacitor-shell';
import { initDeeplinkListener } from '@/platform/deeplink';
import { detectPlatform } from '@/platform/detect';
import { Platform } from '@/platform/types';
import { initAnalytics } from '@/shared/lib/analytics';
import { AppProviders } from './providers';
import { AppRouter } from './router';
import { wireDriverSubscriptions } from './subscriptions';

initAnalytics(detectPlatform());
wireDriverSubscriptions();
initCapacitorShell();
initDeeplinkListener();
registerServiceWorker();

const container = document.getElementById('root');
if (!container) throw new Error('root element missing');

// StrictMode omitted: dev double-invoke causes visible "double fade" through AnimatePresence on route changes.
createRoot(container).render(
  <AppProviders>
    <AppRouter />
  </AppProviders>,
);

// Web only — Discord iframes ban SW registration; native shells (Capacitor/Tauri) use app:// schemes.
function registerServiceWorker(): void {
  if (typeof window === 'undefined') return;
  if (detectPlatform() !== Platform.Web) return;
  if (!('serviceWorker' in navigator)) return;
  if (!import.meta.env.PROD) return;
  navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {
    // SW registration failure is non-fatal — app works without offline cache.
  });
}
